import { Component, ViewChild, ElementRef, AfterViewInit, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormArray, Validators, FormControl } from '@angular/forms';
import { ApiService } from '../../api/api.service';
import { ItistateapiService } from '../../api/itistateapi.service';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { SelectionModel } from "@angular/cdk/collections";

@Component({
  selector: 'app-examformstate',
  templateUrl: './examformstate.component.html',
  styleUrls: ['./examformstate.component.css']
})
export class ExamformstateComponent implements OnInit {

  bdnuForm: any;
  otpForm: any;
  itiForm: any;
  uploadForm:any;

  
  submitted = false;
  submittedOtp = false;
  submittedIti = false;

  state:any;
  reciveuserid:any;
  reciveMobilemo:any;
  reciveemail:any;
  reciveeITIStateCode:any;

  reciveuserstatus:any;
  reciveITIStateCode:any;

  public bool_failure:boolean = false;
  public bool_success:boolean = false;
  public bool_useridForm:boolean =true;
  public bool_otpForm:boolean = false;
  public bool_itiForm:boolean = false;
  public bool_table:boolean = false;
  public bool_Master_table:boolean = false;
  public bool_paynow:boolean  =true;
  public bool_content:boolean = true;
  public bool_form_content:boolean = true;
  public bool_spinner:boolean = false;
  public bool_logout:boolean = true;
  public bool_popup: boolean = false;
  public bool_route:boolean = false;

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  public sel_stateName:any;
  public sel_statekey:any;


  displayedColumns = ['select', 'slno','regno', 'firstname', 'trade', 'exam'];
  SRC_SELECTED_FAMILYMEMBER: Element[] = [];
  DATA_SELECTED_FAMILYMEMBER = Object.assign(this.SRC_SELECTED_FAMILYMEMBER);
  dataSource = new MatTableDataSource<Element>(this.DATA_SELECTED_FAMILYMEMBER);
  selected_family_member = new SelectionModel<Element>(true, []);
  public int_index_edit: any;


  @ViewChild('paginator_Master') paginator_Master!: MatPaginator;
  @ViewChild('sort_Master') sort_Master!: MatSort;

  displayedColumnsMaster = ['slno', 'payrefid', 'payrefdate','noofstu', 'amount', 'ccaveref', 'paymentdate','pstatus', 'upload'];
  SRC_SELECTED_FAMILYMEMBER_Master: Element[] = [];
  DATA_SELECTED_FAMILYMEMBER_Master = Object.assign(this.SRC_SELECTED_FAMILYMEMBER_Master);
  dataSource_Master = new MatTableDataSource<Element>(this.DATA_SELECTED_FAMILYMEMBER);
  selected_family_member_Master = new SelectionModel<Element>(true, []);
  public int_index_edit_Master: any;
  totallength_master:any = 1 ;

  public pduTable: any;
  public query: string = '';
  public page: number = 1;
  public offset: number = 5;
  public pageEvent: any;
  totallength:any = 1 ;

  

  public sessionLogId:any;
  public sessionITIStateCode:any;

public showItiTableData:any;

public ListState:any;

  constructor(private formBuilder: FormBuilder, private api: ApiService, private itistateapi: ItistateapiService,  private router: Router, private httpClient: HttpClient) { }

  ngOnInit(): void {

  
          //window.localStorage.setItem('mobile', result.mobile)
      //window.localStorage.removeItem('candidate_logged');
      //regno: window.localStorage.getItem('candidate_regno'),
      

    this.bdnuForm = this.formBuilder.group({
      userid: ['', Validators.required],
    });

    this.otpForm = this.formBuilder.group({
      userid: ['', Validators.required],
      otp: ['', Validators.required],
    });

    this.itiForm = this.formBuilder.group({
      // ITIStateCode: ['', Validators.required],
      state: ['', Validators.required],
    });

    this.uploadForm = this.formBuilder.group({
      data: ['', new FormControl]
    });

    this.sessionLogId = window.localStorage.getItem('ITIStateLoginId'); 
    this.sessionITIStateCode = window.localStorage.getItem('ITIStateCode'); 

    this.reciveuserid = window.localStorage.getItem('ITIStateLoginId');
      this.reciveemail = window.localStorage.getItem('ITIStateEmail');
      this.reciveMobilemo = window.localStorage.getItem('ITIStateMobile');
      this.reciveeITIStateCode = window.localStorage.getItem('ITIStateCode');



    
  }


  get f() {
    return this.bdnuForm.controls;
  }

  get g() {
    return this.otpForm.controls;
  }

  get h() {
    return this.itiForm.controls;
  }

  onSubmit(){
    
    this.submitted = true;

    if (this.bdnuForm.invalid) {
      return;
    }
    this.bool_spinner = true;

    this.itistateapi.statecheckuserid(this.bdnuForm.value).subscribe((result: any) => {
      

      this.bool_spinner = false;
      console.log(JSON.stringify(result))
      this.reciveuserid = result['userid'];
      this.reciveemail = result['email'];
      this.reciveMobilemo = result['mobile'];



      this.reciveuserstatus = result['status'];
      if(this.reciveuserstatus == 'success'){
        this.bool_useridForm = false;
        this.bool_otpForm = true
      }
      else{
        this.bool_failure = true;

        setTimeout(() => {
          this.bool_success = false;
          this.bool_failure = false;
        }, 5000);
      }
      let count:any = JSON.stringify(result.count);

      if(count == 1){
        console.log(JSON.stringify(result.email))
      }
    });
  }

  logout(){

    this.router.navigateByUrl('/itistatelogin')
    window.localStorage.removeItem('ITIStateLoginId');
    window.localStorage.removeItem('ITIStateEmail');
    window.localStorage.removeItem('ITIStateMobile');
    window.localStorage.removeItem('ITIStateCode');
    window.localStorage.removeItem('ITIStatelogged_in');
    window.localStorage.removeItem('state');
    window.localStorage.removeItem('statekey');

  }

  onOtpSubmit(){
    this.bool_spinner = true;
    this.submitted = true;

    if (this.otpForm.invalid) {
      return;
    }

    this.itistateapi.statecheckOtp(this.otpForm.value).subscribe((result: any) => {
      //PRI210000455924
      this.bool_spinner = false;
      this.reciveITIStateCode = result.data[0]['Code'];
      this.reciveuserstatus = result['status'];
      if(this.reciveuserstatus == 'otp Verified'){
        this.bool_itiForm = true;
        
        this.liststatefn()

        this.bool_useridForm = false;
        this.bool_otpForm = false;

        this.reciveeITIStateCode = result.data[0]['Code'];
  
        window.localStorage.setItem('ITIStateLoginId', this.reciveuserid);
        window.localStorage.setItem('ITIStateEmail', this.reciveemail);
        window.localStorage.setItem('ITIStateMobile', this.reciveMobilemo);
        window.localStorage.setItem('ITIStateCode', this.reciveeITIStateCode);
        
        this.bool_logout = true;

      }
      else{
        this.bool_failure = true;

        setTimeout(() => {
          this.bool_success = false;
          this.bool_failure = false;
        }, 5000);
      }

    });
  }

  liststatefn(){
    this.itistateapi.listITIstate().subscribe((data: any) => {
      this.ListState = data;
      this.itiForm.controls["state"].setValue(this.ListState);
    });
  }
  onItiSubmit(){
    this.submittedIti = true;

    if (this.itiForm.invalid) {
      return;
    }



    this.itistateapi.listITIstateKey(this.itiForm.value).subscribe((res:any)=>{
          this.sel_stateName = res[0]['statename'];
          this.sel_statekey = res[0]['statekey'];

          if(res.status !== 'No data found'){
            this.itistateapi.checkITIApiTable(this.itiForm.value).subscribe((result: any) => {
              
              let count = result[0]['count'];

              if(count == 0){
                alert('data upload')
                this.itistateapi.Statesearch(this.itiForm.value).subscribe((res:any)=>{
                  console.log(JSON.stringify(res));
                  this.pduTable = res;
                  let data:any = [];
              
                  
                  this.pduTable.forEach((value:any)=>{          
                    value['statekey'] =  {state : this.sel_stateName, key: this.sel_statekey};
                    data.push(value);
                  });       
                     console.log(data);
                  this.itistateapi.importITITableAll(data).subscribe((result: any) => {
                    alert(JSON.stringify(result));
                  })
                });    
              }
              else{
                this.bool_form_content = false;
                this.bool_itiForm = false; 
                this.bool_route = true;
                this.router.navigateByUrl('/examfeestate/Showstatetable')
                //alert("show table");
              }
            });
          }
          else{
            alert('state data not valid')
          }
    })


  // this.api.checkApiTable(this.itiForm.value).subscribe((result: any) => {
    
  //   console.log(result[0]['count']);
  //   let count = result[0]['count'];
 
  //   if(count == 0){
  //     this.api.checkApi(this.itiForm.value).subscribe((result: any) => {
  //       this.pduTable = result;
  //       console.log(JSON.stringify(result))
  //       this.api.importTableAll(this.pduTable).subscribe((result: any) => {
          
  //         let status = result.status;
  //         console.log(status)
  //         if(status == 'succes'){
  //           this.api.showItiTable( this.itiForm.value).subscribe((result: any) => {
  //                   this.SRC_SELECTED_FAMILYMEMBER = result;
  //             this.DATA_SELECTED_FAMILYMEMBER = Object.assign(this.SRC_SELECTED_FAMILYMEMBER);
  //             this.dataSource = new MatTableDataSource<Element>(this.DATA_SELECTED_FAMILYMEMBER);
  //             //this.ngAfterViewInit();
  //             this.dataSource.paginator = this.paginator;        
  //             this.dataSource.sort = this.sort;
  //             this.bool_itiForm = false;
  //             this.bool_table = true;
  //             console.log(JSON.stringify(result));
  //             console.log(this.pduTable);
  //             this.totallength = result.length;
  //             console.log(JSON.stringify(result))
  //           });
  //         }
        

  //       });
        
        
  
  //     });
  //   }
  //   else{
  //       this.api.showItiTable(this.itiForm.value).subscribe((result: any) => {
  //         console.log("result" + JSON.stringify(result))
  //         this.SRC_SELECTED_FAMILYMEMBER = result;
  //         this.DATA_SELECTED_FAMILYMEMBER = Object.assign(this.SRC_SELECTED_FAMILYMEMBER);
  //         this.dataSource = new MatTableDataSource<Element>(this.DATA_SELECTED_FAMILYMEMBER);
  //         //this.ngAfterViewInit();
  //         this.dataSource.paginator = this.paginator;        
  //         this.dataSource.sort = this.sort;
  //         this.bool_itiForm = false;
  //         this.bool_table = true;
  //         console.log(JSON.stringify(result));
  //         console.log(this.pduTable);
  //         this.totallength = result.length;
  //         console.log(JSON.stringify(result))
  // });
  //   }

  // });


  }

  onChangeState(data: any) {

    var myargs = {
      stateName: data.target.value
    }
  }

  onItiApiRefresh(){
    this.api.checkApi(this.itiForm.value).subscribe((result: any) => {
      let Apidata = result;
      if(result){
        this.api.checkApiRefresh(Apidata).subscribe((result: any) => {

          this.api.showItiTable(this.itiForm.value).subscribe((result: any) => {
            this.showItiTableData = result;
            this.SRC_SELECTED_FAMILYMEMBER = result;
            this.DATA_SELECTED_FAMILYMEMBER = Object.assign(this.SRC_SELECTED_FAMILYMEMBER);
            this.dataSource = new MatTableDataSource<Element>(this.DATA_SELECTED_FAMILYMEMBER);
            //this.ngAfterViewInit();
            this.dataSource.paginator = this.paginator;        
            this.dataSource.sort = this.sort;
            this.bool_itiForm = false;
            this.bool_table = true;
            console.log(JSON.stringify(result));
            console.log(this.pduTable);
            this.totallength = result.length;
            console.log(JSON.stringify(result))
          });

        })
      }
      // let Apidata = result;
      // let Olddata = this.showItiTableData;
      //       console.log('Apidata' + Apidata.length);
      //       console.log('old data' + Olddata.length);
            

    });
  }
  public seltable:any = [];
 
  logSelection() {

    this.selected_family_member.selected.forEach((s)=>{   
      this.seltable.push(s);
      // this.seltable.concat(JSON.stringify({name: 'nantha'}));
    });
 
    this.seltable.forEach((value:any, key:any) => {
      value['comanId']={commanloginid: this.reciveuserid, commanlemail: this.reciveemail, commanlmobile: this.reciveMobilemo };
    });
    console.log(this.seltable);

    this.api.importTable(this.seltable).subscribe((result: any) => {
      // this.seltable = [];
      // this.selected_family_member.clear() 

      let status = result.status;
      if(status == 'sucess'){
        this.seltable.forEach((value:any, key:any) => {
          value['refid']=result.refid ;
        });
        console.log(this.seltable);

        this.api.importreTable(this.seltable).subscribe((result: any) => {
          let status = result.status;
          if(status == 'succes'){

            this.seltable = [];
          this.selected_family_member.clear();


          
            this.api.showItiTable(this.itiForm.value).subscribe((result: any) => {
              this.SRC_SELECTED_FAMILYMEMBER = result;
              this.DATA_SELECTED_FAMILYMEMBER = Object.assign(this.SRC_SELECTED_FAMILYMEMBER);
              this.dataSource = new MatTableDataSource<Element>(this.DATA_SELECTED_FAMILYMEMBER);
              //this.ngAfterViewInit();
              this.dataSource.paginator = this.paginator;        
              this.dataSource.sort = this.sort;
              console.log(JSON.stringify(result));
              console.log(this.pduTable);
              this.totallength = result.length;

              this.api.showItiMasterTable(this.itiForm.value).subscribe((result: any) => {

                this.itiHeaderName = result[0]['itiname'];
                this.itiHeaderemail = result[0]['ITIStateEmail'];
                this.itiHeaderMobile = result[0]['ITIStateMobile'];
                this.itiHeaderCode = result[0]['ITIStateCode'];

                this.SRC_SELECTED_FAMILYMEMBER_Master = result;
                this.DATA_SELECTED_FAMILYMEMBER_Master = Object.assign(this.SRC_SELECTED_FAMILYMEMBER_Master);
                this.dataSource_Master = new MatTableDataSource<Element>(this.DATA_SELECTED_FAMILYMEMBER_Master);
                //this.ngAfterViewInit();
                this.dataSource_Master.paginator = this.paginator_Master;        
                this.dataSource_Master.sort = this.sort_Master;
                this.bool_itiForm = false;
                console.log(JSON.stringify(result));
                console.log(this.pduTable);
                this.totallength_master = result.length;
                console.log(JSON.stringify(result));
                this.bool_table = false;
                this.bool_Master_table = true;
                });

        


      });
          }
          else{
            
            this.seltable = [];
            this.selected_family_member.clear();
            
          }
        


 
        })

      }else{
      // this.seltable = [];
      // this.selected_family_member.clear() 
      }

    });

  }
    
  fn_import(){
    this.api.importTableAll(this.pduTable).subscribe((result: any) => {

    });
 
    
  }

  applyFilter(event:any){

  }
  
  fn_click(){
    
    this.bool_content = false;
    this.bool_form_content = true;
    
  }

public total_student:any ;
public total_amount:any ;

  isAllSelected() {

    const numSelected = this.selected_family_member.selected.length;
    const numRows = this.dataSource.data.length;

//    console.log("numSelected : "+numSelected);
    
    this.total_student  = numSelected ;
    this.total_amount  = this.total_student * 376 ;
    
    
    if(this.total_student !== 0){
      this.bool_paynow = false;
    }
    else{
      this.bool_paynow = true;
    }

    //console.log(this.total_student)
    return numSelected === numRows;
  }

  masterToggle() {
    // this.isAllSelected() ?
    //     this.selected_family_member.clear() :
    //     this.dataSource.data.forEach(row => this.selected_family_member.select(row));

        if(this.isAllSelected()){
          this.selected_family_member.clear() 
          this.total_student  = 0 ;
          this.total_amount  = this.total_student * 376 ;

          if(this.total_student !== 0){
            this.bool_paynow = false;
          }
          else{
            this.bool_paynow = true;
          }
        }
        else{
          this.dataSource.data.forEach(row => this.selected_family_member.select(row));
        }
  }


  viewMaster(){
    this.bool_table = false;
    this.bool_Master_table = true;
    this.api.showItiMasterTable(this.itiForm.value).subscribe((result: any) => {
    this.SRC_SELECTED_FAMILYMEMBER_Master = result;
    this.DATA_SELECTED_FAMILYMEMBER_Master = Object.assign(this.SRC_SELECTED_FAMILYMEMBER_Master);
    this.dataSource_Master = new MatTableDataSource<Element>(this.DATA_SELECTED_FAMILYMEMBER_Master);
    //this.ngAfterViewInit();
    this.dataSource_Master.paginator = this.paginator_Master;        
    this.dataSource_Master.sort = this.sort_Master;
    this.bool_itiForm = false;
    console.log(JSON.stringify(result));
    console.log(this.pduTable);
    this.totallength_master = result.length;
    console.log(JSON.stringify(result));
    this.itiHeaderName = result[0]['itiname'];
    this.itiHeaderemail = result[0]['ITIStateEmail'];
    this.itiHeaderMobile = result[0]['ITIStateMobile'];
    this.itiHeaderCode = result[0]['ITIStateCode'];

    });
  }

  public itiHeaderName:any; 
  public itiHeaderemail:any; 
  public itiHeaderMobile:any; 
  public itiHeaderCode:any; 
  bcakfn(){
    this.bool_table = true;
    this.bool_Master_table = false;
  }
  
  payMaster(){
    this.selected_family_member_Master.selected.forEach((item:any) => {
      var msg = JSON.stringify(item);
      var msgOb = JSON.parse(msg)
      console.log("MSG: " + msg)
      const formData = new FormData();
      formData.append('data', msg);
    
      var myargs = formData;
      var myargsText = this.uploadForm.value;
      console.log(msgOb.ITIStateCode);
  
   

      let a = {
        userid: msgOb.payrefid,
        amount: msgOb.amount,
        bname: msgOb.itiname,
        baddress: 'nimi',
        bcity: 'chennai',
        bdistrict: msgOb.districtname,
        bstate: msgOb.statename,
        bpincode: '600032',
        bmobile: msgOb.ITIStateMobile,
        bemail: msgOb.ITIStateEmail,
      };

     //window.location.href = 'https://www.nimionlineadmission.in/dgt/paynow.php'

     this.api.payMasterdata(a,"https://www.nimionlineadmission.in/dgt/paynow.php");

           this.selected_family_member_Master.clear() 
      // this.api.payMasterdata(myargs).subscribe((data: any) => {

      // });
      });
  }

  payMasterCancel(){
    this.selected_family_member_Master.selected.forEach((item:any) => {
      var msg = JSON.stringify(item);
      var msgOb = JSON.parse(msg)
      console.log("MSG: " + msg)
      this.api.payMasterdel(msgOb).subscribe((result: any) => {
        let status = result.status;
        console.log(status)
        if(status == 'deleted'){
          this.selected_family_member_Master.clear();
          this.bool_Master_table = false;
          this.api.showItiTable(this.itiForm.value).subscribe((result: any) => {
                  this.SRC_SELECTED_FAMILYMEMBER = result;
            this.DATA_SELECTED_FAMILYMEMBER = Object.assign(this.SRC_SELECTED_FAMILYMEMBER);
            this.dataSource = new MatTableDataSource<Element>(this.DATA_SELECTED_FAMILYMEMBER);
            //this.ngAfterViewInit();
            this.dataSource.paginator = this.paginator;        
            this.dataSource.sort = this.sort;
            this.bool_itiForm = false;
            this.bool_table = true;
            console.log(JSON.stringify(result));
            console.log(this.pduTable);
            this.totallength = result.length;
            console.log(JSON.stringify(result))
          });
        }
      })
    });
  }

  public printView:any;
  payMasterView(){
    
    this.selected_family_member_Master.selected.forEach((item:any) => {
      var msg = JSON.stringify(item);
      var msgOb = JSON.parse(msg)
      console.log("MSG: " + msg);
      
      const formData = new FormData();
      formData.append('data', msg);
    
      var myargs = formData;
      var myargsText = this.uploadForm.value;
      console.log(msgOb.payrefid);
      
      var args = {
        refid: msgOb.payrefid,
        ITIStateCode: msgOb.ITIStateCode
      };

      this.api.showViewPayrefid(args).subscribe((result: any) => {
        console.log(JSON.stringify(result));
        this.printView = result;
        this.bool_Master_table = false;
        this.bool_popup = true;
      });
    });
  }

  omit_number(event: any) {
    var k;
    k = event.charCode;
    return ((k >= 48 && k <= 57) || k == 32);
    // return((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57));
  }

  omit_email(event: any) {
    var k;
    k = event.charCode;
    return ((k > 64 && k < 91) || (k > 96 && k < 123) || (k >= 48 && k <= 57) || k == 45 || k == 46 || k == 64 || k == 95 || k == 32);
  }

  omit_text(event: any) {
    var k;
    k = event.charCode;
    return ((k > 64 && k < 91) || (k > 96 && k < 123) || k == 32);
    // return((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57));
  }
  omit_spl(event: any) {
    var k;
    k = event.charCode;
    return ((k > 64 && k < 91) || (k > 96 && k < 123) || (k >= 48 && k <= 57) || k == 47 || k == 32 || k == 95);
    // return((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57));
  }

  omit_all(event: any) {
    var k;
    k = event.charCode;
    return ((k >= 127 && k <= 0));
    // return((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57));
  }

  whatsapp_bool:boolean = false;
  need_bool:boolean = true
  show_main(){
    this.need_bool = false;
  this.whatsapp_bool = true;
  }
  show_need(){
    this.need_bool = true;
    this.whatsapp_bool = false;
  }

  close_fn(){
    this.bool_popup = false;
    this.bool_Master_table = true;
  }
}

